<div class="general-settings h-full overflow-hidden">
  <ts-page-header [displaySeparationBorder]="true">
    <span page-header-title class="font-ts-header-title text-ts-header-title">General</span>
    <div class="flex justify-end align-center gap-2" page-header-action-buttons>
      <ts-button
        [appAuthorize]="NewPermission.SETTINGS_MANAGE_EXPORTS"
        denyAction="disable"
        type="stroked"
        color="accent"
        icon="ts_file-export"
        [matMenuTriggerFor]="exportMenu"
      >
        Export
      </ts-button>
      <ts-button icon="ts_save" [disabled]="settingsForm.invalid || settingsForm.pristine" (click)="updateSettings()">
        Save
      </ts-button>
    </div>
  </ts-page-header>

  <div class="general-settings__main bg-white h-ts-page-content p-ts-page-content overflow-auto">
    <div class="general-settings__profile-photo mb-4">
      <h6 class="general-settings__profile-photo__title">Company Logo</h6>
      <ts-image-upload
        [imageUrl]="(account$ | async)?.image_url"
        (imageChanged)="onImageChange($event)"
        (imageRemoved)="onImageRemoved()"
      ></ts-image-upload>
    </div>
    <div class="general-settings__form">
      <form class="flex flex-col justify-start items-center w-90" [formGroup]="settingsForm">
        <input formControlName="id" type="hidden" />
        <ts-input label="Account Name" formControlName="name"></ts-input>
        <ts-input label="Subdomain" formControlName="subdomain" readonly></ts-input>
        <mat-form-field class="w-full">
          <mat-label>Display Currency</mat-label>
          <mat-select formControlName="display_currency">
            <mat-option [value]="'USD'">USD</mat-option>
            <mat-option [value]="'CAD'">CAD</mat-option>
            <mat-option [value]="'EUR'">EUR</mat-option>
            <mat-option [value]="'GBP'">GBP</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- We are hiding this feature for now. PM is figuring out where to put it -->
        <ng-container *ngIf="false">
          <fieldset [formGroupName]="'configuration'">
            <mat-checkbox [color]="'primary'" [formControlName]="'show_images_on_pipeline'">
              Show deal images on view
            </mat-checkbox>
            <mat-checkbox [color]="'primary'" [formControlName]="'merge_all_comments_within_object'">
              Combine all comments within an object.
            </mat-checkbox>
          </fieldset>

          <button
            mat-flat-button
            class="mt-10"
            [color]="'primary'"
            [disabled]="settingsForm.invalid || settingsForm.pristine"
            (click)="updateSettings()"
          >
            Save
          </button>
        </ng-container>

        <mat-menu #exportMenu="matMenu">
          <button id="create-project" mat-menu-item (click)="scheduleExport('Projects')">
            <span class="ml-2"> <mat-icon svgIcon="save_alt"></mat-icon> Export Deals </span>
          </button>
          <button mat-menu-item (click)="scheduleExport('PropertyTenants')">
            <span class="ml-2"><mat-icon [svgIcon]="'save_alt'"></mat-icon>Export Leases</span>
          </button>
          <button mat-menu-item (click)="scheduleExport('Offers')">
            <span class="ml-2"><mat-icon [svgIcon]="'save_alt'"></mat-icon>Export Offers</span>
          </button>
          <button mat-menu-item (click)="scheduleExport('Properties')">
            <span class="ml-2"><mat-icon [svgIcon]="'save_alt'"></mat-icon> Export Properties</span>
          </button>
          <button mat-menu-item (click)="scheduleExport('PropertyUnits')">
            <span class="ml-2"><mat-icon [svgIcon]="'save_alt'"></mat-icon>Export Units</span>
          </button>
        </mat-menu>
        <ng-container *ngIf="onlyPostalAllowed">
          <button
            mat-flat-button
            class="mt-5"
            [color]="'primary'"
            DebounceClick
            (debounceClick)="downloadPostalReport()"
          >
            <span>Download Acquisition Report</span>
          </button>
        </ng-container>

        <ts-divider></ts-divider>
        <!--     -->
        <div class="general-settings__color-selection w-full flex flex-col gap-1">
          <p class="font-bold">Colors</p>
          <div>
            <ng-container
              *ngFor="let colorControlGroup of colorsFormArrayControls; index as i; count as c; trackBy: trackByFn"
            >
              <form [formGroup]="colorControlGroup" [ngClass]="{ hidden: colorControlGroup.value._destroy }">
                <div
                  class="general-settings__color-option w-full flex flex-row justify-between items-center px-2 gap-2"
                >
                  <div class="general-settings__color-specs w-full flex flex-row justify-center items-center gap-2">
                    <div
                      class="general-settings__color-bubble min-w-3 min-h-3 rounded-full border border-black-200"
                      [ngStyle]="{ backgroundColor: colorControlGroup?.get('hex_value')?.value || '#E6E6E6' }"
                    ></div>
                    <input
                      class="w-full focus:border-b border-black-200"
                      type="text"
                      maxlength="25"
                      placeholder="Type the color name here..."
                      formControlName="label"
                    />
                    @if (colorControlGroup.value.color_type === 'primary') {
                      <ts-badge value="Primary" type="success"></ts-badge>
                    }
                  </div>

                  <div class="general-settings__color-actions flex flex-row items-center">
                    <ts-button color="accent" icon="ts_palette" type="icon" (click)="openColorPicker(i)"></ts-button>
                    <input
                      colorPicker
                      cpAlphaChannel="disabled"
                      class="w-0"
                      (colorPickerSelect)="onColorSelected($event, i)"
                    />
                    <ts-button
                      color="accent"
                      icon="ts_more"
                      [matMenuTriggerFor]="moreOptions"
                      type="icon"
                      [disabled]="c === 1"
                    ></ts-button>
                    <mat-menu #moreOptions>
                      <button
                        mat-menu-item
                        [disabled]="colorControlGroup.value.color_type === 'primary'"
                        [matTooltip]="
                          colorControlGroup.value.color_type === 'primary'
                            ? 'This color is already the primary color'
                            : null
                        "
                        (click)="onSetPrimaryColor(i)"
                      >
                        <ts-icon icon="ts_star" />
                        <span>Primary</span>
                      </button>
                      <button
                        mat-menu-item
                        [disabled]="colorControlGroup.value.color_type === 'primary'"
                        [matTooltip]="
                          colorControlGroup.value.color_type === 'primary'
                            ? 'You cannot remove the primary color'
                            : null
                        "
                        (click)="removeColor(i)"
                      >
                        <ts-icon icon="ts_trash-alt" color="red" />
                        <span class="text-red-600">Remove</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </form>
            </ng-container>
          </div>
          <div class="mt-2 flex flex-col">
            <small
              class="mb-2 text-center w-full text-black-500 italic"
              *ngIf="colorsFormArray.errors?.duplicateEntries"
            >
              Duplicate entries are not allowed.
            </small>
            <ts-button color="basic" icon="ts_plus" (click)="addNewColor()" [disabled]="colorsFormArray.invalid"
              >Add Color
            </ts-button>
          </div>
        </div>

        <ts-divider></ts-divider>
        <div class="general-settings__enabled-feature-flags w-full flex flex-col gap-1">
          <p class="font-bold">Feature Flags</p>
          @if (termsheetUser()) {
            <ol>
              <li *ngFor="let featureFlag of allFeatureFlags; index as i; count as c; trackBy: trackByFn">
                <mat-checkbox
                  [color]="'primary'"
                  [checked]="enabledFeatureFlags.includes(featureFlag)"
                  (change)="toggleFeatureFlag(featureFlag)"
                >
                  {{ featureFlag }}
                </mat-checkbox>
              </li>
            </ol>
          } @else {
            <ol>
              <ng-container
                *ngFor="let enabledFeatureFlag of enabledFeatureFlags; index as i; count as c; trackBy: trackByFn"
              >
                <li>{{ enabledFeatureFlag }}</li>
              </ng-container>
            </ol>
          }
        </div>

        <ts-divider></ts-divider>
        <div class="general-settings__current-version w-full flex flex-col gap-1">
          <p class="font-bold">Current TermSheet Version</p>
          <p>{{ currentVersion }}</p>
        </div>
      </form>
    </div>
  </div>
</div>
